<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- Navigation for left panel -->
<template>
  <header>
    <div class="logo">
      <img src="../assets/osp.png">
    </div>

    <div class="profile-indicator">
      <div class="placeholder"></div>
      <span>Hello, {{firstName}}</span>
    </div>

    <nav>
      <router-link class="nav-link" active-class="active" to="/calendar"><i class="fal fa-calendar"></i><span>Calendar</span></router-link>
      <router-link v-if="isAdmin" class="nav-link" active-class="active" to="/users"><i class="fal fa-users"></i><span>Users</span></router-link>
      <router-link v-if="isAdmin" class="nav-link" active-class="active" to="/appointment-types"><i class="fal fa-th-large"></i><span>Appointment Types</span></router-link>
      <router-link v-if="isAdmin" class="nav-link" active-class="active" to="/sponsors"><i class="fal fa-address-book"></i><span>Sponsors</span></router-link>
      <router-link v-if="isReviewer || outlookEnabled" class="nav-link" active-class="active" to="/profile"><i class="fal fa-address-card"></i><span>Profile</span></router-link>
      <router-link v-if="isAdmin" class="nav-link" active-class="active" to="/reporting"><i class="fal fas fa-chart-area"></i><span>Reporting</span></router-link>
      <a @click="signOut" class="nav-link sign-out"><i class="fal fa-sign-out-alt"></i><span>Log Out</span></a>
    </nav>
  </header>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import SessionService from '../common/sessionService'

export default defineComponent({
  name: 'Header',

  computed: {
    ...mapState(['firstName']),
    ...mapGetters(['isAdmin', 'isReviewer', 'outlookEnabled'])
  },

  methods: {
    /** sign out */
    signOut () {
      SessionService.logOut()
    }
  }
})
</script>

<style scoped>
.sign-out a {
  cursor: pointer;
}
</style>
